import { omit } from 'lodash'
const localStorageKey = '__graniot_token__'

function client(endpoint, { body, ...customConfig } = {}) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = { 'content-type': 'application/json' }
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: body ? 'POST' : 'GET',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}
	if (body) {
		config.body = JSON.stringify(body)
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			if (r.ok) return r.json()

			if (r.status === 401 && token) {
				window.localStorage.removeItem(localStorageKey)
				window.location.search += ''
			}

			return r.json().then(function (err) {
				throw err
			})
		})
}

export function deleteclient(endpoint, { body, ...customConfig } = {}) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = { 'content-type': 'application/json' }
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: 'DELETE',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			console.log(r)
		})
}

export function patchclient(endpoint, { body, ...customConfig } = {}) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = { 'content-type': 'application/json' }
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: 'PATCH',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}
	if (body) {
		config.body = JSON.stringify(body)
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			if (r.ok) return r.json()

			return r.json().then(function (err) {
				throw err
			})
		})
}

export function multipartclient(
	endpoint,
	{ body, ...customConfig } = {},
	method = null
) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = {}
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: method ? method : body ? 'POST' : 'GET',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}
	if (body) {
		config.body = new FormData()
		body.attachments.forEach((element, index) => {
			config.body.append(`attachments[${index}].attachment`, element)
		})
		for (const [key, value] of Object.entries(
			omit(body, ['attachments'])
		)) {
			const vl =
				key !== 'markers'
					? JSON.stringify(value).replaceAll('"', '')
					: JSON.stringify(value)
			config.body.append(key, vl)
		}
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			if (r.ok) return r.json()

			return r.json().then(function (err) {
				throw err
			})
		})
}

export const handleDownloadShapefile = (data) => {
	const token = window.localStorage.getItem(localStorageKey)
	fetch(
		`${process.env.REACT_APP_BACKEND_API_URL}/catalog/zoning_shapefile/`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		}
	)
		.then(async (response) => {
			if (!response.ok) {
				// Backend returned an error (4xx/5xx) — don't save the body as a binary file.
				// Try to surface a useful message; the body may be JSON, plain text, or an HTML
				// debug page depending on settings.
				let detail = ''
				try {
					const ct = response.headers.get('Content-Type') || ''
					if (ct.includes('application/json')) {
						const j = await response.json()
						detail = j.detail || JSON.stringify(j)
					} else {
						const txt = await response.text()
						detail = txt.length > 300 ? txt.slice(0, 300) + '…' : txt
					}
				} catch (_) {
					// ignore — fall through to generic message
				}
				throw new Error(
					`Download failed (HTTP ${response.status})` + (detail ? `: ${detail}` : '')
				)
			}
			const disposition = response.headers.get('Content-Disposition') || ''
			const match = disposition.match(/filename="?([^"]+)"?/)
			const fallback = data.format === 'PDF Report' ? 'vra_report.pdf' : 'zones.zip'
			const filename = match ? match[1] : fallback
			const blob = await response.blob()
			return { blob, filename }
		})
		.then(({ blob, filename }) => {
			var a = document.createElement('a')
			document.body.appendChild(a)
			a.style = 'display: none'

			var url = window.URL.createObjectURL(blob)
			a.href = url
			a.download = filename
			a.click()
			window.URL.revokeObjectURL(url)
		})
		.catch((err) => {
			// Surface the failure to the user instead of silently doing nothing.
			console.error('zoning download failed:', err)
			// eslint-disable-next-line no-alert
			alert(err.message || 'Download failed. Please try again or contact support.')
		})
}

export function putclient(endpoint, { body, ...customConfig } = {}) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = { 'content-type': 'application/json' }
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: 'PUT',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}
	if (body) {
		config.body = JSON.stringify(body)
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			console.log(r)
		})
}

export function clientPatch(endpoint, { body, ...customConfig } = {}) {
	const token = window.localStorage.getItem(localStorageKey)
	const headers = { 'content-type': 'application/json' }
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	const config = {
		method: 'PATCH',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
		body: JSON.stringify(body),
	}

	return window
		.fetch(`${process.env.REACT_APP_BACKEND_API_URL}/${endpoint}`, config)
		.then((r) => {
			if (r.ok) return r.json()

			if (r.status === 401 && token) {
				window.localStorage.removeItem(localStorageKey)
				window.location.search += ''
			}

			return r.json().then(function (err) {
				throw err
			})
		})
}

// Public client function that uses x-api-key authentication
export function publicClient(endpoint, { body, ...customConfig } = {}) {
	const apiKey = window.localStorage.getItem('graniot_public_api_key')
	const headers = { 'content-type': 'application/json' }
	if (apiKey) {
		headers['x-api-key'] = apiKey
	}
	const config = {
		method: 'GET',
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	}
	if (body) {
		config.body = JSON.stringify(body)
	}

	// Use REACT_APP_API_URL for public endpoints (includes /api prefix)
	const baseUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_API_URL

	return window
		.fetch(`${baseUrl}/${endpoint}`, config)
		.then((r) => {
			if (r.ok) return r.json()

			return r.json().then(function (err) {
				throw err
			})
		})
}

export default client
